import React, { memo, useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Avatar,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
} from "@mui/material";
import { isMobile } from "react-device-detect";
import qs from "qs";
import { isEmpty } from "lodash";

// Components
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import SingleTabEnforcer from "../../components/SingleTabEnforcer/SingleTabEnforcer";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
// Utils & Configs
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
} from "../../utils/GlobalHelper";

// Icons
import ScanThaID_ICON from "../../assets/image/ScanThaID.png";
import DAOL_ICON from "../../assets/image/daol_icon.png";
import ThaID_ICON from "../../assets/image/ThaID2.png";
import circle_ICON from "../../assets/image/circle-exclamation-solid.svg";
import fr_ICON from "../../assets/image/face-id_9648194.svg";

const STATUS_LABELS = {
  LOADING: "LOADING",
  ACCEPTED: "ยืนยันตัวตนสำเร็จ",
};

const STEPS = [
  {
    description: `ดำเนินการพิสูจน์ตัวตนผ่าน<span class='font-DBHeavent font-20' style='color: #AA875E'>ระบบจดจำใบหน้า (Face Recognition)</span>`,
    icon: fr_ICON,
  },
  {
    description: `<span class='font-DBHeavent font-20' style='color: #AA875E'>สแกน QR Code</span> เพื่่อเข้าสู่ระบบ ThaID`,
    icon: ScanThaID_ICON,
  },
  {
    description: "ทำตามขั้นตอน ในแอปพลิเคชัน ThaID จนเสร็จสิ้น",
    icon: ThaID_ICON,
  },
  {
    description: `<span class='font-DBHeavent font-20' style='color:rgb(239, 83, 79)'>กลับมายัง ระบบเปิดบัญชี DAOL SEC เพื่อดำเนินการต่อ</span>`,
    icon: DAOL_ICON,
  },
];

const ThaiDWaiting = (props) => {
  // 🔸 ค่าเบื้องต้นจาก storage และ URL
  const limitfr = 3;
  const translations = getData("Translations");
  const langStorage = getData("lang");
  const idc = getData("idc");
  const refId = getData("refId");
  const ocrUpload = getData("ocrUpload");
  const stepFailedStorage = getData("stepFailed") ?? null;
  const headerManp = getData("HeaderManp") || {};
  const head_token = headerManp.head_token || "";
  const token = headerManp.token || "";
  const channel = ocrUpload ? "OA" : "APPMAN";
  const checkuserinfo = getData("checkuserinfo");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  const ats = getData("f7_ats");
  const bank_ats = getData("f7_bank_ats");

  const urlParams = new URLSearchParams(window.location.search);

  const callback = urlParams.get("callback") || "";

  // 🔸 Header สำหรับ API
  const header = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  // 🔸 React State
  const [lang, setLang] = useState(langStorage);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [activeStep, setActiveStep] = useState(() => {
    const step = parseInt(getData("ActiveStep"));
    return isNaN(step) ? 0 : step;
  });

  const [stepFailed, setStepFailed] = useState(stepFailedStorage);
  const [jumpPage, setJumpPage] = useState(false);
  const [statusFRLimit, setStatusFRLimit] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState("");
  const [modalErrorMssDes, setModalErrorMssDes] = useState("");
  const [valueModal, setValueModal] = useState({
    isMax: false,
    imgError: true,
    imgSuccess: false,
    title: "ท่านสามารถเปลี่ยนธนาคารได้ 3 ครั้ง",
    massage: "กรุณาตรวจสอบที่แอปพลิเคชันของธนาคารก่อน ยืนยันการเปลี่ยนธนาคาร",
    btnPrimary: "ดำเนินการต่อที่",
    btnSecondary: "ยืนยันการเปลี่ยนธนาคาร",
  });
  const checkJumpPage = async () => {
    var stamp_page = getData("stamp_page");
    console.log("==stamp_page", stamp_page);
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      isEmpty(suit) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(ats) ||
      isEmpty(bank_ats) ||
      stamp_page !== "ThaID"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleNext = async () => {
    if (activeStep === 0) {
      const res = await checkLockFR();
      const isOverLimit = parseInt(res?.fr_lock?.Count) >= limitfr;
      if (res?.fr?.Status_Case !== "verified" && !isOverLimit) {
        (!ocrUpload && stepFailed === 0) || !refId
          ? await createCase()
          : await faceRecognize(refId);
      } else if (isOverLimit) {
        let mssDes = `
             <p> 
             ท่านทำรายการพิสูจน์ตัวตนผ่านระบบจดจำใบหน้า <br>(Face Recognition) ครบตามจำนวนครั้งที่กำหนด 
             </p>
             <p>กรุณาติดต่อ DAOL Contact Center 0 2351 1800 <br>เพื่อดำเนินการปลดล็อค หรือสอบถามข้อมูลเพิ่มเติม</p>
           `;
        handleApiError("ดำเนินการพิสูจน์ตัวตนไม่ผ่าน", mssDes);
      }
    } else if (activeStep === 1) {
      setStepFailed(null);
      storeData("stepFailed", null);
      const statustThaID = await ThaIDStatus();
      if (statustThaID !== true) {
        await ThaID();
      }
    }
  };

  const handleBack = () => saveComeback("EKYC");

  const saveComeback = async (type) => {
    try {
      setIsLoading(true);
      storeData("stamp_page", type);
      const last_stamp = JSON.stringify(await getAllStorage(type));
      const url = `${Configs.baseAPIURL03}/form/comeback/manp`;
      const postData = qs.stringify({
        head_token,
        last_stamp,
        stamp_page: type,
      });

      const res = await GlobalApi.post(url, postData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      });

      const isSuccess = res?.data?.Data?.[0]?.[0]?.IsSuccess === 1;
      if (!isSuccess) {
        const message =
          res.data.Data[0].MsgDesc ||
          "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
        showErrorModal("เกิดข้อผิดพลาด", message);
      } else {
        const path =
          type === "EKYC"
            ? "/ekyc"
            : type === "CONFIRM"
              ? "/products_consent"
              : "/";
        props.history.push(path);
      }
    } catch (error) {
      showErrorModal("เกิดข้อผิดพลาด", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  // ฟังก์ชันเกี่ยวกับกระบวนการพิสูจน์ตัวตน
  const ThaID = async () => {
    setIsLoading(true);
    const url = `${Configs.baseAPIURL01}/thai-id/authen`;
    const postData = {
      token: token,
      card_id: idc?.idCard,
      redirect_uri: `${Configs.baseAPIURL09}/thaid_waiting?callback=ThaID`,
    };

    try {
      const res = await GlobalApi.post(url, postData, header);
      const response = res?.data?.data;
      if (response?.MsgDesc?.url) {
        window.open(
          `${response?.MsgDesc?.url}`,
          "_blank",
          "width=800,height=600,scrollbars=yes,resizable=yes",
        );
        storeData("state", response?.MsgDesc?.state);
        checkStatus();
      } else {
        let title = "เกิดข้อผิดพลาด";
        let mss =
          "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
          response +
          ")";
        setIsModalError(true);
        setModalErrorTitle(title);
        setModalErrorMssDes(mss);
      }
    } catch (error) {
      console.error(error);
      let title = "เกิดข้อผิดพลาด";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" + error + ")";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorMssDes(mss);
    } finally {
      setIsLoading(false);
    }
  };

  const faceRecognize = async (Id) => {
    const channel = ocrUpload ? "OA" : "APPMAN";
    setIsLoading(true);
    const body = {
      verification_id: Id,
      redirect_uri: `${Configs.baseAPIURL09}/thaid_waiting?refId=${encodeURIComponent(Id)}`,
      channel: channel,
      token: token,
      head_token: head_token,
    };

    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL01}/face-recognize`,
        body,
        { headers: { "Content-Type": "application/json" } },
      );
      if (res?.data?.data?.url) {
        window.location.href = res?.data?.data?.url;
      } else {
        setIsLoading(false);
        // let title = "เกิดข้อผิดพลาด";
        // let mss =
        //   "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" + res?.data?.data + ")";
        // setIsModalError(true);
        // setModalErrorTitle(title);
        // setModalErrorDes(mss);
        clearData("refId");
        await createCase();
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setIsLoading(false);
      let title = "เกิดข้อผิดพลาด";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
        getData("api_error")?.message +
        ")";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
    }
  };

  const FRInfo = async () => {
    setIsLoading(true);

    const body = {
      verification_id: refId,
      verification_type: "FR",
      card_id: idc?.idCard,
      channel: channel,
      token: token,
      head_token: head_token,
    };

    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL01}/ocr/verify-info`,
        body,
        { headers: { "Content-Type": "application/json" } },
      );

      const info = res.data.data;
      console.log(info);

      if (!info) {
        setStepFailed(0);
        storeData("stepFailed", 0);
        storeData("ocrUpload", false);
        setErrorMessage("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      } else {
        checkLockFR();
      }

      // ดันหน้าใหม่หลังจาก set เสร็จ
      props.history.push("/thaid_waiting");
    } catch (error) {
      console.error("Upload failed:", error);
      setErrorMessage(error?.message || "ไม่สามารถอัปโหลดได้");

      setStepFailed(0);
      storeData("stepFailed", 0);
      storeData("ocrUpload", false);
    } finally {
      setIsLoading(false);
    }
  };

  const ThaIDStatus = async () => {
    const state = getData("state");
    const url = `${Configs.baseAPIURL01}/thai-id/status`;
    const postData = { state: state };
    try {
      const res = await GlobalApi.post(url, postData, header);
      const response = res?.data?.data?.[0]?.[0];
      if (response?.Status === "active") {
        setActiveStep((prev) => prev + 3);
        storeData("pass_ThaID", true);
        sessionStorage.setItem("pass_ThaID", "true");
        setValueModal({
          imgError: false,
          imgSuccess: true,
          title: STATUS_LABELS.ACCEPTED,
          btnPrimary: "ถัดไป",
        });
        setIsModal(true);
        return true; // ✅ สำเร็จ
      } else if (response?.Status?.toLowerCase() === "error") {
        setIsChecking(false);
        setActiveStep(1);
        sessionStorage.setItem("pass_ThaID", "false");
        setStepFailed(1);
        storeData("stepFailed", 1);
        setErrorMessage(
          response?.Error ?? "เกิดข้อผิดพลาด กรุณาทำรายการใหม่อีกครั้ง",
        );
        return "error";
      }
    } catch (error) {
      const apiError = getData("api_error");
      const errorMessage = apiError?.message || "ไม่ทราบสาเหตุ";
      let title = "เกิดข้อผิดพลาด";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(errorMessage);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const createCase = async () => {
    setIsLoading(true);
    const body = { card_id: idc?.idCard };

    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL01}/ocr/create`,
        body,
        { headers: { "Content-Type": "application/json" } },
      );
      if (res?.data?.message === "success") {
        const refId = res?.data?.data?.verification_id;
        storeData("refId", refId);
        await faceRecognize(refId);
      }
    } catch (error) {
      setIsLoading(false);
      let title = "เกิดข้อผิดพลาด";
      let mss =
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
        getData("api_error")?.message +
        ")";
      setIsModalError(true);
      setModalErrorTitle(title);
      setModalErrorDes(mss);
    } finally {
      setIsLoading(false);
    }
  };

  const checkStatus = async () => {
    const TOTAL_DURATION = 60; // จำนวนวินาทีทั้งหมด
    setIsChecking(true);
    setCountdown(TOTAL_DURATION); // เริ่มนับถอยหลังจาก 90 วินาที

    const startTime = Date.now();
    let isSuccess = false;
    let isMounted = true;

    while (Date.now() - startTime < TOTAL_DURATION * 1000 && isMounted) {
      try {
        isSuccess = await ThaIDStatus();
        console.log("เช็คสถานะ:", isSuccess);
      } catch (error) {
        console.error("เกิดข้อผิดพลาดใน ThaIDStatus:", error);
      }

      if (isSuccess) {
        if (isMounted) {
          setIsChecking("active");
          console.log("หยุดเช็คสถานะ: ได้ Status 'active'");
        }
        break;
      }

      const timeElapsed = Math.floor((Date.now() - startTime) / 1000);
      setCountdown(TOTAL_DURATION - timeElapsed); // อัปเดตเวลาที่เหลือ

      await new Promise((res) => setTimeout(res, 1000));
    }

    if (isMounted) {
      setIsChecking(false);
      setCountdown(0);

      if (!isSuccess) {
        setActiveStep(1);
        sessionStorage.setItem("pass_ThaID", "false");
        setStepFailed(1);
        setErrorMessage("หมดเวลาแสดง QR Code กรุณาทำรายการใหม่อีกครั้ง");
        console.log("หยุดเช็คสถานะ: ครบเวลา");
      }
    }
  };

  const formatCountdown = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `( ${m} : ${s} )`;
  };
  const checkLockFR = async () => {
    setIsChecking(true);
    const url = `${Configs.baseAPIURL01}/fr/check-lock`;
    const postData = {
      card_id: idc?.idCard,
      token: token,
    };
    try {
      const res = await GlobalApi.post(url, postData, header);
      const response = res?.data?.data;
      const count = response?.fr_lock?.Count ?? 0;
      const statusCase = response?.fr?.Status_Case ?? "";
      const isOverLimit = parseInt(count) >= limitfr;
      // storeData("refId","2b1c6a29-3972-4c1b-9ed7-7f1c2e95324f")
      if (response) {
        if (isOverLimit) {
          handleFRLimitExceeded();
        } else {
          setStatusFRLimit(false);
          handleFRStatus(statusCase);
        }
      }
      return response;
    } catch (error) {
      console.error("FR check error:", error);
      handleApiError("", error);
      return false;
    } finally {
      setIsChecking(false);
    }
  };

  // Helper function to handle status case
  const handleFRStatus = (status) => {
    console.log(status);

    switch (status) {
      case "verified":
        setStepFailed(null);
        setActiveStep(1);
        storeData("ActiveStep", 1);
        sessionStorage.setItem("pass_fr", true);
        storeData("ocrUpload", true);
        setErrorMessage("");
        // ThaID(refId)
        break;
      case "completed":
        setStepFailed(0);
        storeData("stepFailed", 0);
        storeData("ocrUpload", false);
        setErrorMessage("การสแกนใบหน้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
        break;
      default:
        console.warn("Unknown status:", status);
        break;
    }
  };

  // Helper function for limit exceeded
  const handleFRLimitExceeded = () => {
    setStepFailed(0);
    storeData("stepFailed", 0);
    storeData("ocrUpload", false);
    setStatusFRLimit(true);
    setErrorMessage(
      "ท่านทำรายการพิสูจน์ตัวตนผ่านระบบจดจำใบหน้า (Face Recognition) ครบตามจำนวนครั้งที่กำหนด",
    );
  };

  // Helper function for API error
  const handleApiError = (title, message) => {
    const titleMessage = title || "เกิดข้อผิดพลาด";
    const errorMessage = message || "ไม่ทราบสาเหตุ";
    setIsModalError(true);
    setModalErrorTitle(titleMessage);
    setModalErrorMssDes(errorMessage);
  };
  //-----------------------------
  useEffect(() => {
    const state = getData("state");
    const fetchJumpPage = async () => {
      const res = await checkJumpPage();
      if (res) {
        setJumpPage(true);
        return;
      }
      const refId_url = urlParams.get("refId") || "";
      const state_url = urlParams.get("state") || "";
      if (refId_url && refId.trim() !== decodeURIComponent(refId_url).trim()) {
        setJumpPage(true);
        return;
      }
      if (state_url && state.trim() !== decodeURIComponent(state_url).trim()) {
        setJumpPage(true);
        return;
      }
      // ... (โค้ดตามเดิม)
      // ✅ รีเซตค่าเริ่มต้น
      setStepFailed(null);
      storeData("stepFailed", null);
      setErrorMessage("");
      const shouldCallFR = activeStep === 0 && !refId;
      const shouldCheckStatus = state && activeStep === 1 && !refId;
      // ✅ เรียก FR หรือตรวจสถานะ (เฉพาะกรณีไม่มี headtoken)
      if (activeStep === 0 && refId) {
        checkLockFR();
      }
      if ((shouldCallFR && state) || shouldCheckStatus) {
        ThaIDStatus();
      }
      // ✅ ถ้ามี headtoken_form_url แสดงว่า redirect callback กลับมาแล้ว
      // if (refId) {
      if (refId_url) {
        await FRInfo(); // รอให้ทำงานเสร็จก่อน
      }
      if (callback === "ThaID") {
        try {
          if (window.opener) {
            window.opener.postMessage({ type: "CLOSE_THIS_TAB" }, "*");
            window.close(); // ปิดแท็บตัวเองหากเปิดจาก window.open
          }
        } catch (error) {
          console.warn("ไม่สามารถปิดแท็บเดิมได้:", error);
        }
        ThaIDStatus(); // ตรวจสอบสถานะการยืนยันตัวตนผ่าน ThaID อีกครั้ง
      }
      // }
    };
    fetchJumpPage();
  }, []);
  useEffect(() => {
    if (jumpPage) {
      console.log("jumpPage is true");
      // ทำสิ่งที่ต้องการเมื่อ jumpPage เปลี่ยนเป็น true
    }
  }, [jumpPage]);
  const popUps = async (val, statusError, statusSuccess) => {
    // val -> True is primary button : False is secondary button
    console.log(" popUps");
    console.log(val);
    console.log(statusError);
    console.log(statusSuccess);

    if (statusSuccess) {
      await saveComeback("CONFIRM");
    }
  };
  const isStepFailed = (step) => {
    return step === stepFailed;
  };

  return (
    <>
      <SingleTabEnforcer activeStep={activeStep} jumpPage={jumpPage} />
      <HeaderPage
        title="ยืนยันตัวตนรูปแบบแอปพลิเคชัน ThaID (ไทยดี)"
        onChangeLang={(e) => setLang(e)}
        clickBack={(e) => (e ? handleBack() : "")}
      />
      <Loading status={isLoading} />
      <DialogCustoms
        imgModalError={valueModal.imgError}
        open={isModalError}
        isModel={setIsModalError}
        title={modalErrorTitle}
        massage={modalErrorDes}
        massageDes={modalErrorMssDes}
        btnPrimary={"ตกลง"}
      />
      <DialogCustoms
        open={isModal}
        isModel={setIsModal}
        imgModalError={valueModal.imgError}
        imgModalSuccess={valueModal.imgSuccess}
        switchType={(e) => {
          popUps(e, valueModal.imgError, valueModal.imgSuccess);
        }}
        title={valueModal.title}
        massage={valueModal.massage}
        btnPrimary={valueModal.btnPrimary}
        btnSecondary={valueModal.btnSecondary}
      />
      <Grid className="background-bg">
        <Grid className="section-consent">
          <Grid className={isMobile ? "box-content-mb" : "box-content"}>
            <Grid container className="box-content-main" columns={16}>
              {!isMobile && (
                <Grid item xs={7} className="box-left">
                  <BoxLeftContent
                    translations={translations?.[lang]?.verify}
                    clickBack={(e) => handleBack()}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={isMobile ? 16 : 9}
                className={isMobile ? "box-right-mb" : "box-right"}
              >
                <Grid className="content">
                  <Grid
                    className="box-right-content pb-3"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                      px: 2,
                    }}
                  >
                    {!isMobile && (
                      <HeaderRight title="ยืนยันตัวตนรูปแบบแอปพลิเคชัน ThaID (ไทยดี)" />
                    )}

                    {!isMobile && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexShrink: 0,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            width: "90%",
                            maxWidth: "600px", // กำหนดความกว้างสูงสุดหากต้องการ
                            border: "2px solid #AA875E",
                            borderRadius: "10px",
                            padding: "5px",
                            margin: "2%",
                          }}
                        >
                          <Box
                            sx={{
                              marginRight: "2%",
                              padding: "2%",
                              display: "flex",
                              alignItems: "center",
                              width: "5%",
                            }}
                          >
                            <Avatar
                              alt="daolife-icon"
                              src={circle_ICON}
                              variant="rounded"
                              sx={{ width: 20, height: "auto" }}
                            />
                          </Box>
                          <Box>
                            <Typography
                              className="font-DBHeavent font-18"
                              sx={{
                                color: "#AA875E",
                                lineHeight: "24px",
                              }}
                              variant="span"
                            >
                              **โปรดตรวจสอบให้แน่ใจว่าท่านได้ดำเนินการติดตั้ง
                              และลงทะเบียนแอปพลิเคชัน ThaID เรียบร้อยแล้ว**
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
                    {isMobile && (
                      <Typography
                        className="font-DBHeavent font-18"
                        sx={{
                          color: "#AA875E",
                          lineHeight: "24px",
                          textAlign: "left",
                          pt: 3,
                        }}
                        variant="span"
                      >
                        **โปรดตรวจสอบให้แน่ใจว่าท่านได้ดำเนินการติดตั้ง
                        และลงทะเบียนแอปพลิเคชัน ThaID เรียบร้อยแล้ว**
                      </Typography>
                    )}

                    <ScrollBarComponent
                      content={
                        <Stepper
                          activeStep={activeStep}
                          orientation="vertical"
                          sx={{
                            "& .MuiStepConnector-line": {
                              minHeight: "0px",
                            },
                          }}
                        >
                          {STEPS.map((step, index) => {
                            const labelProps = {};
                            if (isStepFailed(index)) {
                              labelProps.optional = (
                                <Typography
                                  variant="caption"
                                  className="font-DBHeavent font-18"
                                  style={{ color: "#EF534F" }}
                                >
                                  {/* เกิดข้อผิดพลาด กรุณาทำรายการใหม่อีกครั้ง */}
                                  {errorMessage
                                    ? errorMessage
                                    : "เกิดข้อผิดพลาด กรุณาทำรายการใหม่อีกครั้ง"}
                                </Typography>
                              );
                              labelProps.sx = {
                                ...(labelProps.sx || {}),
                                fontSize: 30,
                                color: "warning.main",
                              };
                              labelProps.error = true;
                            }
                            const isActive = index === activeStep;
                            const isCompleted = index < activeStep;
                            const isPending = index > activeStep;

                            return (
                              <Step key={index + 1}>
                                <StepLabel
                                  {...labelProps}
                                  StepIconProps={{
                                    sx: {
                                      fontSize: 30,
                                      color: "#023b6691", // ใช้สีนี้ตอน completed
                                      "&.Mui-completed": {
                                        color: "#023b66",
                                      },
                                      "&.Mui-active": {
                                        color: "#023b66", // เปลี่ยนสี active global
                                      },
                                      "&.Mui-error": {
                                        fontSize: "30px !important", // หรือสีอื่นที่คุณต้องการ
                                      },
                                      "& .MuiStepLabel-label": {
                                        padding: "3% 0px",
                                      },
                                    },
                                  }}
                                >
                                  <Box
                                    id={`step-${index + 1}`}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      width: "100%",
                                      marginBottom: 0,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        mr: 1,
                                        p: 1,
                                        // backgroundColor: "#F7F8FB",
                                        borderRadius: "10px",
                                        // width: "48px",
                                        // height: "48px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Avatar
                                        src={step.icon}
                                        variant="rounded"
                                        sx={{
                                          width: step.icon.includes("img=1")
                                            ? 48
                                            : 50,
                                          height: step.icon.includes("img=1")
                                            ? 12
                                            : "auto",
                                          opacity: isPending ? 0.4 : 1,
                                          filter: isPending
                                            ? "grayscale(100%)"
                                            : "none",
                                        }}
                                      />
                                    </Box>

                                    <Box>
                                      <Typography
                                        className="font-DBHeavent font-18"
                                        sx={{
                                          lineHeight: "22px",
                                          color: isPending
                                            ? "grey.500"
                                            : isActive
                                              ? "#023b66"
                                              : "#023b66",
                                        }}
                                      >
                                        ขั้นตอนที่ {index + 1}
                                      </Typography>
                                      <Typography
                                        className="font-DBHeavent font-20"
                                        sx={{
                                          lineHeight: "24px",
                                          color: isPending
                                            ? "grey.700"
                                            : "#023b66",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: step.description,
                                        }}
                                      ></Typography>
                                    </Box>
                                  </Box>
                                </StepLabel>
                                <StepContent
                                  sx={{
                                    marginTop: 0,
                                    paddingBottom: 0,
                                  }}
                                >
                                  <Box>
                                    <Button
                                      variant="outlined"
                                      onClick={handleNext}
                                      className="font-DBHeavent font-20 btn-next w-50"
                                      sx={{
                                        transform: "unset",
                                        top: "0",
                                        height: "47px !important",
                                        borderColor: isChecking
                                          ? "#ccc !important"
                                          : "primary.main", // เปลี่ยนสีเส้นขอบ
                                        "&.Mui-disabled": {
                                          borderColor: "#ccc !important", // สีขอบเมื่อ disabled
                                          backgroundColor: "#ccc !important", // พื้นหลังเมื่อ disabled (optional)
                                        },
                                      }}
                                      disabled={isChecking}
                                    >
                                      {isChecking && activeStep === 1
                                        ? "กำลังตรวจสอบ...  " +
                                          formatCountdown(countdown)
                                        : translations?.[lang]?.verify
                                            ?.next_waiting}
                                    </Button>
                                  </Box>
                                </StepContent>
                              </Step>
                            );
                          })}
                        </Stepper>
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(ThaiDWaiting);
